/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import MenuMobile from '../components/MenuMobile';
import '../style/menuMobile.css';

const MobileMenu = () => {
  const [showIcon, setShow] = useState(true);
  const [hiddenOn, setHiddenOn] = useState(true);

  function openMenu() {
    if (showIcon) {
      setShow(false);
      setHiddenOn(false);
    } else {
      setShow(true);
      setTimeout(() => {
        setHiddenOn(true);
      }, 100);
    }
  }

  useEffect(() => {
    window.addEventListener('resize', () => {
      if (window.innerWidth > 899) {
        setHiddenOn(true);
        setShow(true);
      }
      return false;
    });
    return false;
  }, []);

  return (
    <>
      <div onClick={() => openMenu()}>
        { showIcon ? <MenuIcon className="menu-icon" sx={{ fontSize: 45 }} /> : false }
      </div>
      <div hidden={hiddenOn} id={showIcon ? 'close-slide' : 'slide'}>
        <MenuMobile openMenu={openMenu} />
      </div>
    </>
  );
};

export default MobileMenu;
